import React from 'react';
import { Collapse } from 'antd';
import { Caixa } from './styles';

export default function CaixaDeFiltros({ children }) {
  return (
    <Collapse>
      <Caixa header="Filtros" key="1">
        {children}
      </Caixa>
    </Collapse>
  );
}
